import RateReviewIcon from '@material-ui/icons/RateReview';
import { resourceWrapper } from '../../Components/ui/utils';
import { ResourceExport } from '../../types/resource-export.type';
import ReviewDetails from './ReviewDetails';
import ReviewList from './ReviewList';

const Review: ResourceExport = {
  list: ReviewList,
  // create: resourceWrapper('create', ReviewDetails, undefined, undefined),
  edit: resourceWrapper('edit', ReviewDetails, undefined, undefined),
  show: resourceWrapper('show', ReviewDetails, undefined, undefined),
  icon: RateReviewIcon,
};

export default Review;
